import React from "react";
import { FormattedMessage } from "react-intl";

import Input from "components/Input";

import "./style.scss";

const NumbersRange = ({
  label = "",
  value = { from: "", to: "" },
  handleChange,
  name = ""
}) => (
  <div className="range-datepicker-block">
    <FormattedMessage id={label} tagName="label" />
    <div className="range-block">
      <Input
        value={value.from}
        pattern="[0-9]*"
        onChange={e => handleChange(e, `${name}.from`)}
      />
      <span className="date-label">
        <FormattedMessage id="DATE_LABEL" />
      </span>
      <Input
        value={value.to}
        pattern="[0-9]*"
        onChange={e => handleChange(e, `${name}.to`)}
      />
    </div>
  </div>
);

export default NumbersRange;
